import type { SVGProps } from 'react';

export const ShippingboxSFSymbolMedium = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 20.2504 21.5557"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="21.5557" opacity="0" width="20.2504" x="0" y="0" />{' '}
        <path
          d="M1.4041 17.0106L9.13535 21.3292C9.66992 21.6311 10.2174 21.6311 10.7617 21.3292L18.4832 17.0106C19.4238 16.487 19.8891 15.936 19.8891 14.5571L19.8891 6.66455C19.8891 5.62256 19.5039 4.96319 18.6344 4.4751L11.7678 0.624906C10.5598-0.0541958 9.3293-0.0541958 8.12129 0.624906L1.26269 4.4751C0.385156 4.96319 0 5.62256 0 6.66455L0 14.5571C0 15.936 0.473242 16.487 1.4041 17.0106ZM2.46054 15.5106C1.92577 15.2157 1.73749 14.8995 1.73749 14.387L1.73749 7.26532L9.04258 11.3913L9.04258 19.2278ZM17.4348 15.5106L10.8447 19.2278L10.8447 11.3913L18.1516 7.26532L18.1516 14.387C18.1516 14.8995 17.9633 15.2157 17.4348 15.5106ZM9.94765 9.79562L2.72498 5.746L5.45078 4.19677L12.6805 8.25713ZM14.527 7.23487L7.28202 3.179L8.89863 2.26396C9.60839 1.86415 10.2771 1.85263 10.9967 2.26396L17.1721 5.746Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
